import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import FilterContainer from '../../../components/FilterContainer/FilterContainer';

import FilterForm from './FilterForm';

import './FilterServiceRequest.scss';

const FilterServiceRequest = forwardRef(
  ({ show, title, hideModal, isFilterPinned, onAnchor, showAnchor }, ref) => (
    <FilterContainer
      isPinned={isFilterPinned}
      onAnchor={onAnchor}
      onClose={hideModal}
      ref={ref}
      show={show}
      showAnchor={showAnchor}
      style={{ backgroundColor: 'white', borderRadius: '5px' }}
      title={title}
    >
      <FilterForm />
    </FilterContainer>
  )
);

FilterServiceRequest.displayName = 'FilterServiceRequest';

FilterServiceRequest.propTypes = {
  hideModal: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  onAnchor: PropTypes.func.isRequired,
  isFilterPinned: PropTypes.bool.isRequired,
  showAnchor: PropTypes.bool.isRequired
};
FilterServiceRequest.defaultProps = {
  hideModal: null,
  show: false,
  title: ''
};

export default FilterServiceRequest;
